import script from "./comment-actions-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./comment-actions-bar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__